import i18next from 'i18next';

i18next.addResources('es_CL', 'orientation', {
  message: 'Rota tu celular para ver el contenido'
});

i18next.addResources('es_CR', 'orientation', {
  message: 'Rota tu celular para ver el contenido'
});
